import { DatePipe } from "@angular/common";
import { FormatStyle } from "../model/enums/SaveMode";
import { ModelMapAbstract } from "../model/ModelMapAbstract";

export class ExcelExportService {

datePipe: DatePipe = new DatePipe('en-us');

  export(model: any[], modelMap: ModelMapAbstract, fileName: string) {

    let headerString = this.buildHeader(modelMap);

    let bodyString = this.buildBody(model, modelMap);

    let exportData = `<table>${headerString + bodyString}</table>`;

    let downloadLink;
    downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.href = 'data:text/csv, ' + exportData;

    // Setting the file name
    downloadLink.download = fileName + '.xls';

    //triggering the function
    downloadLink.click();
    document.body.removeChild(downloadLink);

  }


  buildHeader(modelMap: ModelMapAbstract): string {
    let header: string = '';
    modelMap.fieldSettings.forEach(v => {
      if (!(v[1] == undefined))
        header += `<th>${v[0]}</th>`
    })
    return header;
  }

  buildBody(model: any[], modelMap: ModelMapAbstract) {
    let body: string = '';
    model.forEach(d => {
      body += '<tr>';
      modelMap.fieldSettings.forEach(v => {
        if ((d[v[1]] == undefined)) {
          body += `<td></td>`
        }
        else {
          body += `<td>${escape(this.formatValue(d[v[1]], v[2] as FormatStyle))}</td>`
        }
      })
      body += '</tr>';
    });

    return body;
  }

  formatValue(value: any, format: FormatStyle): any {
    
    if (format == FormatStyle.DDMMYYYY)
      return this.datePipe.transform(value,'dd-MM-yyyy');

    return value;
  }

}
